import { SLIDER_CONFIG } from './Constants';
import type { SlickConfig, SlickResponsiveSettings } from './Types';
/**
 * Slider Configuration Builder
 * Creates Slick slider configuration with responsive breakpoints
 */
export default class SliderConfigBuilder {
    prevArrow: JQuery<HTMLElement>;
    nextArrow: JQuery<HTMLElement>;
    mobilePrevArrow: JQuery<HTMLElement>;
    mobileNextArrow: JQuery<HTMLElement>;

    /**
     * @param prevArrow - Desktop previous arrow element
     * @param nextArrow - Desktop next arrow element
     * @param mobilePrevArrow - Mobile previous arrow element
     * @param mobileNextArrow - Mobile next arrow element
     */
    constructor(prevArrow: JQuery<HTMLElement>, nextArrow: JQuery<HTMLElement>, mobilePrevArrow: JQuery<HTMLElement>, mobileNextArrow: JQuery<HTMLElement>) {
        this.prevArrow = prevArrow;
        this.nextArrow = nextArrow;
        this.mobilePrevArrow = mobilePrevArrow;
        this.mobileNextArrow = mobileNextArrow;
    }

    /**
     * Builds complete Slick configuration object
     * @returns Slick slider configuration
     */
    build(): SlickConfig {
        return {
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: SLIDER_CONFIG.DESKTOP_ROWS,
            adaptiveHeight: false,
            prevArrow: this.prevArrow,
            nextArrow: this.nextArrow,
            speed: SLIDER_CONFIG.TRANSITION_SPEED,
            responsive: this._buildResponsiveSettings()
        };
    }

    /**
     * Builds responsive breakpoint settings
     * @private
     * @returns Responsive configuration array
     */
    private _buildResponsiveSettings(): SlickResponsiveSettings[] {
        const baseSettings = {
            slidesToShow: 1,
            slidesToScroll: 1,
            rows: 1,
            centerMode: true,
            prevArrow: this.mobilePrevArrow,
            nextArrow: this.mobileNextArrow
        };

        return [
            {
                breakpoint: 768,
                settings: { ...baseSettings, centerPadding: SLIDER_CONFIG.MOBILE_CENTER_PADDING_LARGE }
            },
            {
                breakpoint: 640,
                settings: { ...baseSettings, centerPadding: SLIDER_CONFIG.MOBILE_CENTER_PADDING_MEDIUM }
            },
            {
                breakpoint: 480,
                settings: { ...baseSettings, centerPadding: SLIDER_CONFIG.MOBILE_CENTER_PADDING_SMALL }
            }
        ];
    }
}

